module.exports = __webpack_public_path__ + "img/pipes.173b62b6.svg";